import React from "react";
import { profileSections } from "./CardProfile";
import { inr, cardTitle } from "./util";

export default function CardCompareTable({ existing, recs }) {
  const cols = [
    ...existing.filter((e) => e.profile?.status === "ready").map((e) => ({ key: `e-${e.issuer}-${e.card_name}`, label: cardTitle(e.issuer, e.card_name), tag: "Current", p: e.profile, v: e.value })),
    ...recs.filter((r) => r.profile?.status === "ready").slice(0, 3).map((r) => ({ key: r.product_id, label: cardTitle(r.issuer, r.card_name), tag: "On Crece", p: r.profile, v: r.value })),
  ];
  if (cols.length < 2) return null;
  const sections = cols.map((c) => profileSections(c.p));
  return (
    <div className="rounded-2xl border border-stone-200 bg-white overflow-x-auto" data-testid="cl-compare-table">
      <table className="w-full text-xs min-w-[640px]">
        <thead>
          <tr className="bg-[#FBF8F1]">
            <th className="text-left p-3 w-40 sticky left-0 bg-[#FBF8F1] font-black uppercase tracking-wider text-stone-500 text-[10px]">Side by side</th>
            {cols.map((c) => <th key={c.key} className="text-left p-3 align-bottom"><div className="text-[10px] font-bold text-stone-400 uppercase">{c.tag}</div><div className="font-black text-sm text-stone-900">{c.label}</div></th>)}
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-stone-100 bg-[#E8F3EE]/40">
            <td className="p-3 font-bold sticky left-0 bg-[#F2F8F5]">Net value for these spends</td>
            {cols.map((c) => <td key={c.key} className="p-3 font-display font-black text-base text-[#0B4D3A]" data-testid={`cl-compare-value-${c.key}`}>{c.v ? inr(c.v.net_value) : "—"}<span className="text-[10px] font-sans font-bold text-stone-400"> /yr</span></td>)}
          </tr>
          {sections[0].map(([k, label], ri) => (
            <tr key={k} className="border-t border-stone-100" data-testid={`cl-compare-row-${k}`}>
              <td className="p-3 font-bold text-stone-700 sticky left-0 bg-white">{label}</td>
              {sections.map((s, ci) => <td key={cols[ci].key} className="p-3 align-top"><div className="font-bold text-stone-900">{s[ri][2]}</div>{s[ri][3] && <div className="text-stone-500 mt-0.5 line-clamp-3">{s[ri][3]}</div>}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
